import { render } from "./SidebarContent.vue?vue&type=template&id=7185ba54&scoped=true"
import script from "./SidebarContent.vue?vue&type=script&lang=js"
export * from "./SidebarContent.vue?vue&type=script&lang=js"

import "./SidebarContent.vue?vue&type=style&index=0&id=7185ba54&scoped=true&lang=css"
import "./SidebarContent.vue?vue&type=style&index=1&id=7185ba54&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7185ba54"]])

export default __exports__